import React from 'react';
import { PlayerProps } from './PlayerProps';
import { useSelector } from 'react-redux';
import getPlayerKit from '../../helpers/getPlayerKit';
import { setActiveSelectValue } from '../../features/input/thunks';
import StyledPlayer from './StyledPlayer';
import { selectRedCardEvents, selectYellowCardEvents } from '../../features/match/matchSlice';
import YellowCardWithShirtNumber from '../eventIcons/YellowCardWithShirtNumber';
import RedCardWithShirtNumber from '../eventIcons/RedCardWithShirtNumber';
import { useAppDispatch } from '../../hooks/hooks';

const Substitute: React.FC<PlayerProps> = ({ player, kit }) => {
  const dispatch = useAppDispatch();
  const redCardEvents = useSelector(selectRedCardEvents);
  const yellowCardEvents = useSelector(selectYellowCardEvents);

  if (player.startsMatch) {
    return null;
  }

  const Kit = getPlayerKit(kit.patternId);

  let redCard = false;
  if (redCardEvents.length > 0) {
    redCardEvents.forEach((matchEvent) => {
      if (matchEvent.person?.id === player.personId) {
        redCard = true;
      }
    });
  }

  let yellowCard = false;
  if (yellowCardEvents.length > 0) {
    yellowCardEvents.forEach((matchEvent) => {
      if (matchEvent.person?.id === player.personId) {
        yellowCard = true;
      }
    });
  }

  const setPlayer = () => {
    dispatch(setActiveSelectValue(player.personId));
  };

  return (
    <StyledPlayer onClick={setPlayer}>
      {redCard && (
        <div>
          <RedCardWithShirtNumber shirtNumber={player.shirtNumber > 0 ? player.shirtNumber.toString() : ''} />
        </div>
      )}
      {yellowCard && (
        <div>
          <YellowCardWithShirtNumber shirtNumber={player.shirtNumber > 0 ? player.shirtNumber.toString() : ''} />
        </div>
      )}
      {!redCard && !yellowCard && <Kit shirtNumber={player.shirtNumber ? player.shirtNumber : ' '} kit={kit} />}
      <div className="name">{player.shirtName}</div>
    </StyledPlayer>
  );
};

export default Substitute;
